<template>
    <section ref="maltButtonSlide" class="malt-button-slice">
        <VJoyButton
            :href="slice.primary.link ? $withLocalePrefix(slice.primary.link) : undefined"
            variant="main"
            data-component-source="resources-success-story-button"
        >
            {{ slice.primary.text }}
        </VJoyButton>
    </section>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ButtonSlice} from '@prismicio-types';
    import {useComponentTracking} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';

    defineProps(getSliceComponentProps<ButtonSlice>());

    const maltButtonSlide = ref(null);

    useComponentTracking(maltButtonSlide);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '~/assets/styles/variables' as *;

    .malt-button-slice {
        display: flex;
        justify-content: center;
        margin-top: var(--joy-core-spacing-6);
        margin-bottom: var(--joy-core-spacing-10);
        @include content-width($article-max-width);

        .joy-button {
            width: 100%;
            @include mq.screen_sm(min) {
                width: auto;
            }
        }
    }
</style>
